import { Injectable } from '@angular/core';
import { State } from '../select-account.reducer';

@Injectable({ providedIn: 'root' })
export class SelectAccountSessionStorageService {
   private readonly selectedAccountStorageKey = 'NDT_SELECTED_ACCOUNT';

   clearAll(): void {
      sessionStorage.clear();
      localStorage.clear();
   }

   removeSelectedAccount(): void {
      sessionStorage.removeItem(this.selectedAccountStorageKey);
      localStorage.removeItem(this.selectedAccountStorageKey);
   }

   getSelectedAccount(): State | null {
      const sessionData = sessionStorage.getItem(this.selectedAccountStorageKey);
      const localData = localStorage.getItem(this.selectedAccountStorageKey);
      if (sessionData) {
         return JSON.parse(sessionData);
      }else if(localData){
         return JSON.parse(localData);
      }
      return null;
   }

   setSelectedAccount(state: State): void {
      sessionStorage.setItem(this.selectedAccountStorageKey, JSON.stringify(state));
      localStorage.setItem(this.selectedAccountStorageKey, JSON.stringify(state));
   }
}
